let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aRM0u")).then(() => parcelRequire('bfHRy'));